module.exports = __webpack_public_path__ + "static/media/ray_huang.4f4c8011.png";